// extracted by mini-css-extract-plugin
export default {"item":"ItemMenu_item__wx1HM","pressed":"ItemMenu_pressed__3pBBt","open":"ItemMenu_open__Fs0Kt"};